import { render, staticRenderFns } from "./PermitsDueReport.vue?vue&type=template&id=210f7464"
import script from "./PermitsDueReport.vue?vue&type=script&lang=js"
export * from "./PermitsDueReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports